export default __webpack_public_path__ + "static/media/file.cd9c071e.svg";